export default __webpack_public_path__ + "static/roadmap_25-d990ec812a300d6c4760877878884eb3.png";